// Filtre anti-désintermédiation : empêche l'insertion de coordonnées de contact
// (email / téléphone) dans les champs libres visibles par l'autre partie, pour
// que les échanges passent par la messagerie Festin.

const EMAIL_RE = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/;
// Téléphone FR : +33 ou 0X suivi de 4 groupes de 2 chiffres (espaces/points/tirets tolérés).
const PHONE_FR_RE = /(?:\+33|0)\s?[1-9](?:[\s.-]?\d{2}){4}/;

export interface ContactCheck {
  hasContact: boolean;
  reasons: ('email' | 'phone')[];
}

/** Détecte email et/ou téléphone dans un texte libre. */
export function detectContactInfo(text: string): ContactCheck {
  const reasons: ('email' | 'phone')[] = [];
  if (EMAIL_RE.test(text)) reasons.push('email');
  if (PHONE_FR_RE.test(text)) reasons.push('phone');
  return { hasContact: reasons.length > 0, reasons };
}

export const CONTACT_BLOCK_MESSAGE =
  "Merci de ne pas inclure d'adresse email ou de numéro de téléphone dans votre message. Toutes les communications passent par la messagerie Festin.";
